export default __webpack_public_path__ + "static/media/profile-A-1_LS.54385c59.png";